// This file is stored in this repository but it will be executed in GTM
// To deploy this file to GTM we copy the content here into a GTM snippet
// For better source control, always merge any change to master before deploying to GTM
// More at: https://shippo.atlassian.net/wiki/spaces/TA/pages/931365076/Tech+Design+Marketing+source+tracking+during+registration

// This file needs to be written in vanilla JS and support all browsers

let COOKIE_NAME = 'shippoUTM';
let COOKIE_EXPIRES_IN_DAYS = 60;
let SUBDOMAIN_WHITELIST = ['lets', 'get', 'track'];

const isURLSupported = () => {
  // Taken from https://github.com/lifaon74/url-polyfill/blob/75c2deb52c40f252bd6cc75b4e2aaf0ead837a11/url-polyfill.js#L264
  try {
    let u = new global.URL('b', 'http://a');
    u.pathname = 'c d';
    return u.href === 'http://a/c%20d' && u.searchParams;
  } catch (e) {
    return false;
  }
};

const getQueryString = () => {
  let keyValuePairs = window.location.search.slice(1).split('&');
  let queryString = {};

  keyValuePairs.forEach((pair) => {
    pair = pair.split('=');

    if (pair.length && pair.length === 2) queryString[pair[0]] = decodeURIComponent(pair[1] || '');
  });

  return queryString;
};

const getCookie = (cookieName) => {
  let name = cookieName + '=';
  let cookieArray = document.cookie.split(';');
  let cookieString = null;

  cookieArray.forEach((cookie) => {
    cookie = cookie.replace(/^\s+|\s+$/g, '');

    if (cookie.indexOf(name) > -1) cookieString = cookie.substring(name.length, cookie.length);
  });

  if (cookieString !== null) {
    try {
      return JSON.parse(decodeURIComponent(cookieString));
    } catch (e) {
      return {};
    }
  }

  return {};
};

const setCookie = (cookie, value, expires) => {
  let parsedCurrentURL = parseURL(window.location.href);
  if (typeof expires === 'undefined') {
    expires = new Date();
    expires.setDate(expires.getDate() + COOKIE_EXPIRES_IN_DAYS);
  }
  let cookieString =
    cookie +
    '=' +
    value +
    '; domain=' +
    parsedCurrentURL.domain +
    '.com; path=/; expires=' +
    expires.toUTCString();
  document.cookie = cookieString;
};

const arrayIntersects = (firstArray, secondArray) =>
  secondArray.some((v) => firstArray.indexOf(v) >= 0);

const getReferrerCodeFromQS = (QS) => QS.rsCode || QS.gclid || QS.msclkid || QS.sh_cl || null;

const parseURL = (url) => {
  let hostname = '';
  let parsedURL = {};

  // URL API is not supported in IE
  if (isURLSupported()) {
    let urlObject = new URL(url);
    hostname = urlObject.hostname;
  } else {
    // Fallback only for IE
    let a = document.createElement('a');
    a.href = url;
    hostname = a.hostname;
  }

  // Hostname will always be subdomain.domain.tld or domain.tld
  let splitHostname = hostname.replace('www.', '').split('.');
  if (splitHostname.length === 3) {
    parsedURL.subdomain = splitHostname[0];
    parsedURL.domain = splitHostname[1];
  } else {
    parsedURL.subdomain = null;
    parsedURL.domain = splitHostname[0];
  }

  return parsedURL;
};

const isOffDomain = (domain) => {
  let parsedCurrentURL = parseURL(window.location.href);

  return domain !== parsedCurrentURL.domain;
};

const getUpdatedSourceAttributionObject = (queryString, storedValues) => {
  let utmParameters = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'sh_device',
    'sh_matchtype',
  ];
  let additiveValues = ['sh_ad1', 'sh_ad2', 'sh_ad3', 'sh_ad4'];
  let newValues = {};
  let wasUpdated = false;

  // Check if query string is not empty
  let queryStringkeys = Object.keys(queryString);
  if (queryStringkeys.length > 0) {
    let URLHasUTMParameters = arrayIntersects(queryStringkeys, utmParameters);
    let referrerCode = getReferrerCodeFromQS(queryString);
    wasUpdated = true;

    if (URLHasUTMParameters) {
      // Extract from the URL if present
      utmParameters.forEach((tag) => {
        if (queryString[tag]) newValues[tag] = queryString[tag];
      });
    } else {
      // Extract from stored values if present
      utmParameters.forEach((tag) => {
        if (storedValues[tag]) newValues[tag] = storedValues[tag];
      });
    }

    additiveValues.forEach((tag) => {
      // If one of the additive values is present in the URL store it. If not fallback to stored values
      // If none of them are present, do nothing
      if (queryString[tag] || storedValues[tag])
        newValues[tag] = queryString[tag] || storedValues[tag];
    });

    if (referrerCode) newValues.attribution_snippet = referrerCode;
    else if (storedValues.attribution_snippet)
      newValues.attribution_snippet = storedValues.attribution_snippet;
  } else {
    newValues = storedValues;
  }

  // Only store referrer if is not present
  if (!storedValues.http_referrer) {
    let referrerURL = document.referrer;

    if (referrerURL) {
      let parsedReferrerURL = parseURL(referrerURL);

      // Store referrer only if it's off-domain or on-domain but the subdomain is whitelisted
      if (
        isOffDomain(parsedReferrerURL.domain) ||
        (!isOffDomain(parsedReferrerURL.domain) &&
          SUBDOMAIN_WHITELIST.indexOf(parsedReferrerURL.subdomain) > -1)
      ) {
        newValues.http_referrer = referrerURL;
        wasUpdated = true;
      }
    }
  } else {
    newValues.http_referrer = storedValues.http_referrer;
  }

  return {
    newValues,
    wasUpdated,
  };
};

const setAttributionCookie = () => {
  let queryString = getQueryString();
  let storedValue = getCookie(COOKIE_NAME);

  let results = getUpdatedSourceAttributionObject(queryString, storedValue);

  if (results.wasUpdated)
    setCookie(COOKIE_NAME, encodeURIComponent(JSON.stringify(results.newValues)));
};

setAttributionCookie();

export {
  arrayIntersects,
  getCookie,
  // Just for testing
  getQueryString,
  getReferrerCodeFromQS,
  getUpdatedSourceAttributionObject,
  parseURL,
  setAttributionCookie,
  setCookie,
};
